// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"SignupCategory__materialize-textarea___2Y_F-","modal-2463794813":"SignupCategory__modal-2463794813___2cE-B","container":"SignupCategory__container___34BoP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SignupCategory/SignupCategory.scss
// module id = 1535
// module chunks = 0